import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.385 41.943a.999.999 0 1 0-.023 1.997c.342.004.686.006 1.032.006 6.652 0 12.25-.707 16.802-2.128a3.995 3.995 0 0 0 2.75-4.469l-.843-5.066a6.99 6.99 0 0 0-6.293-5.818c-3.816-.33-7.955-.496-12.416-.496-.355 0-.71.001-1.06.003a.999.999 0 0 0 .011 1.998c.348-.002.698-.003 1.05-.003 4.405 0 8.486.162 12.243.488a4.994 4.994 0 0 1 4.495 4.156l.842 5.066a1.997 1.997 0 0 1-1.375 2.234c-4.339 1.356-9.742 2.038-16.206 2.038-.339 0-.675-.002-1.009-.006Zm-6.518-29.956a7.989 7.989 0 0 0 7.99 7.99 7.989 7.989 0 0 0 7.99-7.99 7.989 7.989 0 0 0-7.99-7.99 7.989 7.989 0 0 0-7.99 7.99Zm-1.997 0C16.87 6.471 21.34 2 26.857 2c5.516 0 9.987 4.47 9.987 9.987 0 5.516-4.47 9.987-9.987 9.987-5.516 0-9.987-4.47-9.987-9.987ZM3.997 34.957a8.988 8.988 0 0 0 8.989 8.989 8.988 8.988 0 0 0 8.988-8.988 8.988 8.988 0 0 0-8.988-8.989 8.988 8.988 0 0 0-8.989 8.989Zm-1.997 0c0-6.067 4.918-10.985 10.986-10.985 6.068 0 10.986 4.917 10.986 10.986 0 6.067-4.918 10.985-10.986 10.985C6.918 45.943 2 41.026 2 34.958Zm12.973.931-2.278 2.305a.963.963 0 0 0 .014 1.37.982.982 0 0 0 1.38-.013l3.907-3.952a.964.964 0 0 0-.007-1.364l-3.906-3.875a.982.982 0 0 0-1.381 0 .963.963 0 0 0 0 1.37l2.239 2.221H8.386c-.41 0-.744.434-.744.97 0 .534.333.968.744.968h6.587Z",
    fill: "currentColor"
  }));
};

var SvgAssigned = styled(SvgComponent).withConfig({
  displayName: "Assigned__SvgAssigned",
  componentId: "sc-19ih579-0"
})(["", " ", ""], size, color);
export default SvgAssigned;